<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        集团与园区单位管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="ml20  f18 blue cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
    <div class="common-page common-body">
      <div class="flex" style="justify-content:flex-end">
        <div class="btn ml10" @click="addList()"><i class="icon-tr-newly-added"></i>新增</div>
      </div>
      <div class="common-page common-list">
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>
                单位名称
              </th>
              <th>单位类型</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td class="common-add">
                <el-select v-model="item.company_num" filterable>
                  <el-option :label="it.c_name" :value="it.c_company_num" v-for="(it, ind) in units">
                    {{ it.c_name }}
                  </el-option>
                </el-select>
              </td>
              <td class="common-add">
                <el-checkbox-group style="height:30px" v-model="item.services" @change="handlechange">
                  <el-checkbox label="1" key="评估">集团 </el-checkbox>
                  <el-checkbox label="2" key="维保"> 园区</el-checkbox>
                </el-checkbox-group>
              </td>
              <td class="td-btn">
                <a class="clear-data">
                  <i class="icon-tr-edit" @click="onSubmit(item, index)"></i>
                </a>
                <el-popconfirm title="确定禁用单位记录吗？" class="cursor" @onConfirm="del(item, index)" @confirm="del(item, index)">
                  <a slot="reference" class="red">
                    <i class=" icon-tr-delete"></i>
                  </a>
                </el-popconfirm>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="btn-box">
                <div class="l-btn" @click="onSubmit">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [{ company_num: "", company_type: 1, services: [], type: 1 }],
      params: { name: "", page: 1 },
      units: [],
    };
  },
  created() {
    this.$post("/devicemanage/selectconpanybyme").then((res) => {
      console.log(res);
      this.units = res.data;
    });
    this.getList();
  },
  methods: {
    handlechange(val) {
      console.log(val);
    },
    onSubmit(item) {
      item.company_type = item.services.join(",");
      this.$post("/user/addgroup", item).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
      });
    },

    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post("/user/grouplist", this.params).then((res) => {
        // return

        this.list = res.data.list || [];
        this.list.map((item, index) => {
          var service = item.company_type.split(",");
          this.$set(this.list[index], "services", service);
        });
      });
    },
    del(item, index) {
      if (!item.company_num) {
        this.list.splice(index, 1);
        return;
      }
      this.$post(`/user/deletegroup/${item.company_num}`).then((res) => {
        // this.$message.success("删除成功");
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.list.splice(index, 1);
      });
    },
    addList() {
      this.list.push({ company_num: "", company_type: 1, services: [], type: 1 });
    },
  },
};
</script>

<style scoped>
.common-add label {
  color: black;
}
</style>
